import { california } from './California';
import { idaho } from './Idaho';
import { minnesota } from './Minnesota';
import { nevada } from './Nevada';
import { newjersy } from './NewJersy';
import { newmexico } from './NewMexico';
import { pennsylvania } from './Pennsylvania';
import { georgia } from './Georgia';
import { virginia } from './Virginia';
import { getinsured } from './GetInsured';

export const headerConfig = {
    'CA': california,
    'ID': idaho,
    'MN': minnesota,
    'NV': nevada,
    'NJ': newjersy,
    'NM': newmexico,
    'PA': pennsylvania,
    'GA': georgia,
    'VA': virginia,
    'GI': getinsured

};